import { render, staticRenderFns } from "./ListaPermisosSCT.vue?vue&type=template&id=774f6fd3&"
import script from "./ListaPermisosSCT.vue?vue&type=script&lang=js&"
export * from "./ListaPermisosSCT.vue?vue&type=script&lang=js&"
import style0 from "./ListaPermisosSCT.vue?vue&type=style&index=0&id=774f6fd3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports